import {ApiError, OnUploadProgress} from '@mintdata-wsp/common/controllers/network/Fetcher';
import {FileResponse} from '@mintdata-wsp/common/controllers/network/generated/responses/FileResponse';
import {commonControllers} from '@mintdata-wsp/common/controllers/CommonControllers';
import {API} from '@mintdata-wsp/common/controllers/network/WorkspaceAPI';
import {IFilesProps, UploadedFile} from '@mintdata/mint-kit/api/file/IFilesProps';
import bind from 'bind-decorator';

export class FilesController
{
    public getProps():IFilesProps
    {
        return {
            uploadFile: this.uploadFile
        };
    }

    @bind
    public async uploadFile(file:File, forceContentType:string, forceFileExtension:string,
                            onProgress:OnUploadProgress, uploadCancelledPromise?:Promise<any>):Promise<UploadedFile>
    {
        const organizationSid = commonControllers.context.currentOrganizationSid();

        const formData = new FormData();
        formData.append('filename', file.name);
        if( forceFileExtension && forceFileExtension.trim().length > 0 )
            formData.append('forceFileExtension', forceFileExtension.trim());

        if( forceContentType && forceContentType.trim().length > 0 )
            formData.append('forceContentType', forceContentType.trim());

        // !! contents should go last, so it can be parsed in a stream-fashion on a server
        formData.append('contents', file);

        const response = await API.files.uploadFile(organizationSid, formData, onProgress, uploadCancelledPromise) as FileResponse | ApiError;
        if( ApiError.isError(response) )
            return Promise.reject((response as ApiError).message);

        return response as FileResponse as UploadedFile;
    }
}
